import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_el_option = _resolveComponent("el-option");
    const _component_el_select = _resolveComponent("el-select");
    const _component_label_form = _resolveComponent("label-form");
    return (_openBlock(), _createBlock(_component_label_form, null, {
        default: _withCtx(() => [
            _createVNode(_component_el_select, _mergeProps({
                modelValue: _ctx.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value) = $event)),
                placeholder: _ctx.placeholder || 'Select',
                disabled: _ctx.disabled
            }, Object.assign(Object.assign({}, (_ctx.multiple && {
                multiple: true,
                collapseTags: true
            })), _ctx.searchAble()), {
                style: { "width": "100%" },
                clearable: "",
                onChange: _ctx.change
            }), {
                default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.optionsValue, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value,
                            title: item.label
                        }, null, 8 /* PROPS */, ["label", "value", "title"]));
                    }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
            }, 16 /* FULL_PROPS */, ["modelValue", "placeholder", "disabled", "onChange"])
        ]),
        _: 1 /* STABLE */
    }));
}
